import XIcon from "@/shared-components/icons/components/public/XIcon";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";
import Text from "@/shared-components/text/components/Text";

import "./styles/PopUpDrafts.css";

const PopUpDrafts = ({ open, close, DraftsList }) => {
  return (
    <GenericPopup open={open} darkerBlur>
      <div className="pop-up-drafts">
        <div className="pop-up-drafts__header">
          <Text className=" pop-up-drafts__header-text" medium>
            Drafts
          </Text>
          <XIcon className="pop-up-drafts__header-Xicon" onClick={close} />
        </div>
        <div className="pop-up-drafts__list">
          <DraftsList/>
        </div>
        
      </div>
    </GenericPopup>
  );
};

export default PopUpDrafts;